/**
 * API Configuration
 * In production (Vercel), all /api/* calls are proxied to the backend via vercel.json rewrites.
 * In development, the full localhost URL is used.
 */

const isLocalhost = typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.endsWith('.local') ||
    window.location.hostname.startsWith('192.168.') ||
    window.location.hostname.startsWith('10.') ||
    window.location.hostname.startsWith('172.'));

const envValue = process.env.REACT_APP_USE_BACKEND_API;

// Smarter Default: Use backend API if explicitly true OR if we're in production (not localhost)
export const USE_BACKEND_API = envValue === 'true' || (!isLocalhost && envValue !== 'false');

// In production, use a relative /api path so requests are proxied by Vercel.
// This hides the actual Render backend URL from browser network logs.
// In development, use localhost.
const currentHostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const defaultLocalUrl = `http://${currentHostname}:3002/api`;

// Only use the environment variable if it doesn't look like a production URL on a local machine
// unless the user explicitly wants to test production locally.
// Force production to always use the Vercel proxy (/api) regardless of what is set in Vercel Environment Variables.
// This permanently bypasses any stale REACT_APP_API_URL values stuck in Vercel.
const envApiUrl = process.env.REACT_APP_API_URL;
const rawApiUrl = isLocalhost 
  ? (envApiUrl?.includes('onrender.com') ? defaultLocalUrl : (envApiUrl || defaultLocalUrl))
  : '/api'; // ALWAYS use /api in production so vercel.json handles routing

export const API_BASE_URL = rawApiUrl
  .replace(/\/+$/, '') // Remove trailing slashes
  .replace(/(?<!\/api)$/, '/api') // Ensure ends with /api if it doesn't already
  .replace(/\/api\/api$/, '/api'); // Fix double /api/api if it happened


// Debug logging silenced for production pristine console.
